<template lang="pug">
v-container(
    fluid
  )
  v-row
    p.title.ml-3 媒體報表
  v-row
    v-col(cols='12')
      v-card.d-flex
        v-col(cols="4")
          date-range-picker(
            label="日期"
            v-model="condition.range"
          )
        v-spacer
        v-btn.my-auto.mx-4(
          text
          icon
          @click="exportReport"
        )
          v-icon(
            color="darken-2"
          ) mdi-cloud-download
  v-row
    v-col(cols='12')
      v-card
        v-simple-table(
        )
          template(v-slot:default)
            thead
              tr
                th Request
                th 廣告曝光
                th 可視曝光
                th Click
                th Trueview
                th CTR
                th Fillrate
                th eCPM
                th 收益
            tbody
              tr
                td {{ total.request }}
                td {{ total.exposure }}
                td {{ total.valid }}
                td {{ total.click }}
                td {{ total.trueview }}
                td {{ percentage(total.click, total.exposure) }}%
                td {{ percentage(total.exposure, total.request) }}%
                td {{ dividend(total.profit, total.exposure) }}
                td {{ total.profit }}

  v-row
    v-col(cols='12')
      v-card
        v-simple-table(
        )
          template(v-slot:default)
            thead
              tr
                th 媒體
                th Request
                th 廣告曝光
                th 可視曝光
                th Click
                th Trueview
                th CTR
                th Fillrate
                th eCPM
                th 收益
                th
            tbody
              tr(
                v-for="report in reports"
                :key="report.index"
              )
                td {{ report.application_name }}
                td {{ report.request }}
                td {{ report.exposure }}
                td {{ report.valid }}
                td {{ report.click }}
                td {{ report.trueview }}
                td {{ percentage(report.click, report.exposure) }}%
                td {{ percentage(report.exposure, report.request) }}%
                td {{ dividend(report.profit, report.exposure) }}
                td {{ report.profit }}
                td
                  v-btn(
                    small
                    outlined
                    :to="toParams(report)"
                  ) 詳情

</template>

<script>
import moment from 'moment';
import { map, pluck, debounceTime } from 'rxjs/operators';
import DateRangePicker from '@/components/DateRangePicker.vue';
import { dividend, percentage, toQueryString } from '@/plugins/utils';

export default {
  name: 'publisher-report',
  components: {
    DateRangePicker,
  },
  props: [
    'publisherId',
  ],
  data() {
    return {
      show: [],
      headers: [],
      total: {
        request: 0,
        exposure: 0,
        click: 0,
        trueview: 0,
        valid: 0,
        profit: 0,
      },
      reports: [],
      condition: {
        range: [
          moment().format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD'),
        ],
        group: ['application'],
      },
    };
  },
  subscriptions() {
    return {
      detail: this.$watchAsObservable('condition', {
        deep: true,
      }).pipe(
        pluck('newValue'),
        debounceTime(300),
        map(this.getReport),
      ),
    };
  },
  methods: {
    getReport() {
      const totalPara = toQueryString({
        start: this.condition.range[0],
        end: this.condition.range[1],
      });
      this.$axios.get(`/publisher/${this.publisherId}/report?${totalPara}`)
        .then((res) => {
          const [total] = res.data.data;
          this.total = total;
        });
      const infoPara = toQueryString({
        start: this.condition.range[0],
        end: this.condition.range[1],
        group: this.condition.group.join(','),
      });
      this.$axios.get(`/publisher/${this.publisherId}/report?${infoPara}`)
        .then((res) => {
          this.reports = res.data.data;
          this.show = this.condition.group;
        });
    },
    toParams(report) {
      return {
        name: 'application-report',
        params: {
          applicationId: report.application_id,
          applicationName: report.application_name,
        },
      };
    },
    exportReport() {
      const totalPara = toQueryString({
        start: this.condition.range[0],
        end: this.condition.range[1],
      });
      const apiUrl = this.$axios.defaults.baseURL;
      window.location.assign(`${apiUrl}/publisher/${this.publisherId}/report/export?${totalPara}`);
    },
    dividend,
    percentage,
  },
  beforeMount() {
    this.getReport();
  },
};
</script>
